import { defineComponent, useTemplateRef, ref, watch, openBlock, createElementBlock, Fragment, createVNode, unref, withCtx, createTextVNode, normalizeStyle, mergeProps } from 'vue';
import _sfc_main$1 from '../../../component/dialog/dialog.vue.js';
import '@ssml-editor/core';
import { Button } from '@ssml-editor/vue';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
import '@ssml-editor/modules';
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
import { useElementBounding } from '../../../node_modules/.pnpm/@vueuse_core@14.2.1_vue@3.5.31_typescript@5.9.3_/node_modules/@vueuse/core/dist/index.js';
import { VOICE_CONTENT_DATA_STORE_KEY } from './constant.js';
import { VoiceContentData } from './data.js';
import VoiceContent from './voice-content.js';
import { VoiceMenuUtils } from './voice-menu-utils.js';
import { VoiceStorageType } from './voice-storage-type.enum.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "voice-menu",
  props: {
    storageType: { default: VoiceStorageType.NONE },
    storeName: { default: VOICE_CONTENT_DATA_STORE_KEY },
    reader: { type: Function, default: () => {
      return Promise.resolve(void 0);
    } },
    saver: { type: Function, default: () => {
      return Promise.resolve(true);
    } },
    categoryPageSize: {},
    voicePageSize: {},
    fetchVoices: {},
    fetchCategories: {},
    searchVoices: {},
    config: {},
    editor: {}
  },
  setup(__props) {
    const menuBarButtonRef = useTemplateRef("menu-bar-button");
    const voiceContentRef = useTemplateRef("voice-content");
    const dialogVisible = ref(false);
    const voiceContentData = ref(new VoiceContentData());
    const { x, y, height } = useElementBounding(menuBarButtonRef);
    const margin = ref("");
    const props = __props;
    function show() {
      margin.value = `${y.value + height.value}px 0 0 ${x.value}px`;
      dialogVisible.value = true;
    }
    function hide() {
      dialogVisible.value = false;
    }
    async function menuClickHandler() {
      const { editor } = props;
      if (editor) {
        const data = await VoiceMenuUtils.getData(editor);
        data && (voiceContentData.value = data);
        show();
      }
    }
    async function submitHandler() {
      const { editor, config, storageType, storeName, saver } = props;
      const data = voiceContentRef.value?.getData();
      if (data && editor && config && config.databaseName) {
        await VoiceMenuUtils.saveData(
          editor,
          config.databaseName,
          storageType,
          storeName,
          saver,
          data
        );
      }
      hide();
    }
    watch(
      props,
      (newValue) => {
        const { editor, config, storageType, storeName, reader } = newValue;
        if (editor && config && config.databaseName) {
          VoiceMenuUtils.setProps(editor, {
            storageType,
            storeName,
            reader,
            databaseName: config.databaseName
          });
        }
      },
      {
        immediate: true
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(Button), {
          ref: "menu-bar-button",
          "icon-class": "iconfont-ssml-editor icon-ssml-editor-duoren",
          onClick: menuClickHandler
        }, {
          default: withCtx(() => [
            createTextVNode("音色")
          ]),
          _: 1
        }, 512),
        createVNode(unref(_sfc_main$1), {
          title: "音色",
          width: "calc(var(--el-dialog-padding-primary) * 2 + 12.5rem)",
          "destroy-on-close": true,
          modelValue: dialogVisible.value,
          "onUpdate:modelValue": ($event) => dialogVisible.value = $event,
          style: normalizeStyle({ margin: margin.value }),
          onSubmit: submitHandler
        }, {
          default: withCtx(() => [
            createVNode(VoiceContent, mergeProps({
              ref: "voice-content",
              modelValue: voiceContentData.value,
              "onUpdate:modelValue": ($event) => voiceContentData.value = $event
            }, props), null, 16, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue", "style"])
      ], 64);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=voice-menu.vue.js.map
